module.exports = __webpack_public_path__ + "static/media/design-theme-panel.4293fa06.png";